import React, { Component } from "react";
import { Layout } from "antd";
import "./ContentRoutes.css";
import { Route } from "react-router-dom";

import HomePage from '../pages/HomePage';
import SobrePage from '../pages/SobrePage';

import PedidosPage from "../pages/PedidosPage";
import EntregasPage from "../pages/EntregasPage";
import ContagemEstoquePage from "../pages/ContagemEstoquePage";
import EstoqueProducaoPage from "../pages/EstoqueProducaoPage";

import AtividadesPage from "../pages/AtividadesPage";
import AtividadesVendedoresPage from "../pages/AtividadesVendedoresPage";
import ContasAReceberPage from "../pages/ContasAReceberPage";

import VendasVendedoresPage from "../pages/VendasVendedoresPage";
import VendasGradePage from "../pages/VendasGradePage";
import CarteiraClientesPage from "../pages/CarteiraClientesPage";
import MapaVendasPage from "../pages/MapaVendasPage";
import ProdutosVendidosPage from "../pages/ProdutosVendidosPage";

import ClientesPage from "../pages/ClientesPage";
import ProdutosPage from "../pages/ProdutosPage";
import GruposPage from "../pages/GruposPage";
import MarcasPage from "../pages/MarcasPage";
import MedidasPage from "../pages/MedidasPage";
import GradesTipoPage from "../pages/GradesTipoPage";
import GradesTamanhoPage from "../pages/GradesTamanhoPage";
import CondPagtosPage from "../pages/CondPagtosPage";
import StatusVendasPage from "../pages/StatusVendasPage";
import StatusEntregasPage from "../pages/StatusEntregasPage";
import TabelaDescontosPage from "../pages/TabelaDescontosPage";
import TabelaFretesPage from "../pages/TabelaFretesPage";

import OrdemProducaoPage from "../pages/OrdemProducaoPage";
import MonitorProducaoPage from "../pages/MonitorProducaoPage";
import LinhasProducaoPage from "../pages/LinhasProducaoPage";
import TiposAnalisesPage from "../pages/TiposAnalisesPage";
import ProdutosTiposAnalisesPage from "../pages/ProdutosTiposAnalisesPage";
import StatusProducaoPage from "../pages/StatusProducaoPage";
import CategoriaAnaliseProducaoPage from "../pages/CategoriaAnaliseProducaoPage";
import AnaliseProducaoPage from "../pages/AnaliseProducaoPage";

import UsuariosPage from "../pages/UsuariosPage";
import EmpresaMetasPage from "../pages/EmpresaMetasPage";
import UsuariosMetasPage from "../pages/UsuariosMetasPage";
import UsuariosSupervisoresPage from "../pages/UsuariosSupervisoresPage";
import UsuariosProdutosPage from "../pages/UsuariosProdutosPage";
import AlterarSenhaPage from "../pages/AlterarSenhaPage";
import EmpresasPage from "../pages/EmpresasPage";

import GruposUsuariosPage from "../pages/GruposUsuariosPage";
import PermissoesPage from "../pages/PermissoesPage";
import LogPage from "../pages/LogPage";

const { Content } = Layout;

export default class ContentRoutes extends Component {
  state = {};
  render() {
    return (
      <Content className="contentRoutes">
        <div>
          <Route path="/" exact component={HomePage} />
          <Route path="/pedidos" exact component={PedidosPage} />
          <Route path="/entregas" exact component={EntregasPage} />
          <Route path="/atividades" exact component={AtividadesPage} />
          <Route path="/atividadesVendedores" exact component={AtividadesVendedoresPage} />
          <Route path="/contagemEstoque" exact component={ContagemEstoquePage} />
          <Route path="/estoqueProducao" exact component={EstoqueProducaoPage} />
          
          <Route path="/contasAReceberPage" exact component={ContasAReceberPage} />

          <Route path="/vendasVendedores" exact component={VendasVendedoresPage} />
          <Route path="/vendasGrade" exact component={VendasGradePage} />
          <Route path="/carteiraClientes" exact component={CarteiraClientesPage} />
          <Route path="/mapaVendas" exact component={MapaVendasPage} />
          <Route path="/produtosVendidos" exact component={ProdutosVendidosPage} />

          <Route path="/clientes" exact component={ClientesPage} />
          <Route path="/produtos" exact component={ProdutosPage} />
          <Route path="/grupos" exact component={GruposPage} />
          <Route path="/gradesTamanho" exact component={GradesTamanhoPage} />
          <Route path="/gradesTipo" exact component={GradesTipoPage} />
          <Route path="/marcas" exact component={MarcasPage} />
          <Route path="/medidas" exact component={MedidasPage} />
          <Route path="/condPagtos" exact component={CondPagtosPage} />
          <Route path="/statusVendas" exact component={StatusVendasPage} />
          <Route path="/statusEntregas" exact component={StatusEntregasPage} />
          <Route path="/tabelaDescontos" exact component={TabelaDescontosPage} />
          <Route path="/tabelaFretes" exact component={TabelaFretesPage} />

          <Route path="/ordemProducao" exact component={OrdemProducaoPage} />
          <Route path="/monitorProducao" exact component={MonitorProducaoPage} />
          <Route path="/linhasProducao" exact component={LinhasProducaoPage} />
          <Route path="/tiposAnalises" exact component={TiposAnalisesPage} />
          <Route path="/produtosTiposAnalises" exact component={ProdutosTiposAnalisesPage} />
          <Route path="/statusProducao" exact component={StatusProducaoPage} />
          <Route path="/categoriaAnaliseProducao" exact component={CategoriaAnaliseProducaoPage} />
          <Route path="/analiseProducao" exact component={AnaliseProducaoPage} />

          <Route path="/usuarios" exact component={UsuariosPage} />
          <Route path="/empresaMetas" exact component={EmpresaMetasPage} />
          <Route path="/vendedoresMetas" exact component={UsuariosMetasPage} />
          <Route path="/vendedoresSupervisores" exact component={UsuariosSupervisoresPage} />
          <Route path="/vendedoresProdutos" exact component={UsuariosProdutosPage} />
          <Route path="/empresas" exact component={EmpresasPage} />
          <Route path="/gruposUsuarios" exact component={GruposUsuariosPage} />
          <Route path="/permissoes" exact component={PermissoesPage} />
          <Route path="/log" exact component={LogPage} />
          <Route path="/alterarSenha" exact component={AlterarSenhaPage} />
          <Route path="/sobre" exact component={SobrePage} />
        </div>
      </Content>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/ContentRoutes.js